export var onEmulator = window.location.hostname === ('localhost') || window.location.hostname.startsWith('192.168');
export var defaultBlobStorage = "https://hashimukhstorage.blob.core.windows.net/";
export var defaultPublicBlobStorage = defaultBlobStorage + "public/";
export var logoLegacyUrl = defaultPublicBlobStorage + "company_logo_transparent_compact_153x200.png";
export var braindingFBLogoUrl = defaultPublicBlobStorage + "third-party/branding/FindUs-FB-RGB-BRC-Site-500.png";
export var printFBLogoUrl = defaultPublicBlobStorage + "third-party/branding/f_Logo_CMYK-C_Blue_144.png";
export var bkashNumber = "+880 1647-318996";
//# sourceMappingURL=constants.js.map